// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
    ContentLayout,
    Header,
    SpaceBetween,
} from '@cloudscape-design/components';
import CreateAccountDiagramNameForm from './CreateAccountDiagramNameForm';
import {useAccounts} from '../../../../Hooks/useAccounts';

const CreateAccountDiagramPage = () => {
    const {data: accounts = []} = useAccounts();

    return (
        <ContentLayout
            header={
                <Header
                    variant="h1"
                    description="Create a diagram for a specific AWS account showing all resources and their relationships"
                >
                    Create Account Diagram
                </Header>
            }
        >
            <SpaceBetween size="l">
                <CreateAccountDiagramNameForm
                    direction="vertical"
                    accounts={accounts}
                />
            </SpaceBetween>
        </ContentLayout>
    );
};

export default CreateAccountDiagramPage;
